import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: ()=>import('../view/home'),
    },
    {
      path: '/login',
      name: 'login',
      component: ()=>import('@/view/login'),
    },
    {
      path: '/forget',
      name: 'forget',
      component: ()=>import('@/view/forget'),
    },
    {
      path: '/ticheng',
      name: 'ticheng',
      component: ()=>import('@/view/ticheng'),
    },
    {
      path: '/dingdan',
      name: 'dingdan',
      component: ()=>import('@/view/dingdan'),
    },
    {
      path: '/daifuwu',
      name: 'daifuwu',
      component: ()=>import('@/view/daifuwu'),
    },
    {
      path: '/fuwuzhong',
      name: 'fuwuzhong',
      component: ()=>import('@/view/fuwuzhong'),
    },
    {
      path: '/yiwancheng',
      name: 'yiwancheng',
      component: ()=>import('@/view/yiwancheng'),
    },
    {
      path: '/kehu',
      name: 'kehu',
      component: ()=>import('@/view/kehu'),
    },
    {
      path: '/yihezuo',
      name: 'yihezuo',
      component: ()=>import('@/view/yihezuo'),
    },
    {
      path: '/weihezuo',
      name: 'weihezuo',
      component: ()=>import('@/view/weihezuo'),
    },
    {
      path: '/yuyue',
      name: 'yuyue',
      component: ()=>import('@/view/yuyue'),
    },
    {
      path: '/mine',
      name: 'mine',
      component: ()=>import('@/view/mine'),
    },
    {
      path: '/newkehu',
      name: 'newkehu',
      component: ()=>import('@/view/newkehu'),
    },
    {
      path: '/toushu',
      name: 'toushu',
      component: ()=>import('@/view/toushu'),
    },
    {
      path: '/address',
      name: 'address',
      component: ()=>import('@/view/address'),
    },
    {
      path: '/news',
      name: 'news',
      component: ()=>import('@/view/news'),
    },
    {
      path: '/newsdetail',
      name: 'newsdetail',
      component: ()=>import('@/view/newsdetail'),
    },
    // {
    //   path: '/yuyue',
    //   name: 'yuyue',
    //   component: '',
    //   info:{
    //     name:'订单预约',
    //     icon:'icon-uniE900',
    //   },
    //   children:[]
    // },
    // {
    //   path: '/kehu',
    //   name: 'kehu',
    //   component: '',
    //   info:{
    //     name:'我的客户',
    //     icon:'icon-6',
    //   },
    //   children:[]
    // },
    // {
    //   path: '/newkehu',
    //   name: 'newkehu',
    //   component: '',
    //   info:{
    //     name:'添加新客户',
    //     icon:'icon-3',
    //   },
    //   children:[]
    // },
    // {
    //   path: '/toushu',
    //   name: 'toushu',
    //   component: '',
    //   info:{
    //     name:'投诉意见',
    //     icon:'icon-4',
    //   },
    //   children:[]
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js